import { Outlet } from 'react-router-dom';
import { Box, Stack } from '@mui/material';
//
import MainFooter from './MainFooter';
import MainHeader from './MainHeader';

// ----------------------------------------------------------------------

export default function MainLayout() {
  return (
    <Stack sx={{ minHeight: '100vh' }}>
      <MainHeader />

      <Box component="main" sx={{ flexGrow: 1 }}>
        <Outlet />
      </Box>

      <MainFooter />
    </Stack>
  );
}
